// Reactivo, cuando cambia el state se notifica a todos lados donde esten escuchando los cambios del state
export default () => ({
  nombre: "",
  correo: "",
  rol: "",
  token: "",
  userSession: false,
  drawing: false,
  logged_in: "no",
  // Nuevos
  loginAuth: null,
  itemCarreras: [],
  itemEstancias: [],
  showAlert: false,
  dataAlert: {},
})
